import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchNoticeDetails } from '../../services/publicTendersApi';
import AuctionDetails_CN from './AuctionDetails_CN';
import AuctionDetails_SCN from './AuctionDetails_SCN';
import AuctionDetails_RFQ from './AuctionDetails_RFQ';
import AuctionDetails_PC from './AuctionDetails_PC';
import AuctionDetails_DC from './AuctionDetails_DC';
import AuctionDetails_RFD from './AuctionDetails_RFD';

/**
 * Router component care încarcă detaliile procedurii folosind mongoId din URL,
 * detectează tipul procedurii din datele încărcate (specificView.noticeNo)
 * și afișează componenta corespunzătoare cu datele pre-fetchuite.
 */
const AuctionDetailsRouter = () => {
  const { noticeNo: id } = useParams();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const data = await fetchNoticeDetails(id);
        if (mounted) setDetails(data);
      } catch (err) {
        if (mounted) setError(err.message);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [id]);

  if (loading) {
    return (
      <main className="container mx-auto px-4 py-8">
        <div style={{ padding: '2rem 0' }}>Se încarcă…</div>
      </main>
    );
  }

  if (error || !details) {
    return (
      <main className="container mx-auto px-4 py-8">
        <p className="error-text">Eroare: {error || 'Nu există date disponibile.'}</p>
      </main>
    );
  }

  // Determine procedure type from the loaded data
  const noticeNo = details.specificView?.noticeNo || '';
  const getProcedureType = (noticeNo) => {
    if (!noticeNo) return 'SCN';
    const upper = noticeNo.toUpperCase();
    if (upper.startsWith('CN')) return 'CN';
    if (upper.startsWith('SCN')) return 'SCN';
    if (upper.startsWith('RFQ')) return 'RFQ';
    if (upper.startsWith('PC')) return 'PC';
    if (upper.startsWith('DC')) return 'DC';
    if (upper.startsWith('RFD')) return 'RFD';
    return 'SCN';
  };

  const procedureType = getProcedureType(noticeNo);

  const componentMap = {
    CN: AuctionDetails_CN,
    SCN: AuctionDetails_SCN,
    RFQ: AuctionDetails_RFQ,
    PC: AuctionDetails_PC,
    DC: AuctionDetails_DC,
    RFD: AuctionDetails_RFD,
  };

  const Component = componentMap[procedureType] || AuctionDetails_SCN;

  // Pass pre-fetched data so child components don't re-fetch
  return <Component noticeNo={noticeNo} procedureType={procedureType} prefetchedDetails={details} mongoId={id} />;
};

export default AuctionDetailsRouter;
